import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchBlogPost(ctx, slug) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/posts/${slug}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
